import axios from "axios";
import Cookie from 'js-cookie'

export const axiosintance = axios.create({
    baseURL: "https://pm-backend-six.vercel.app/api/v1",
    // baseURL: "http://localhost:8080/api/v1",
    // headers: {
    //   Authorization: `Bearer ${Cookie.get('token')}`
    // },
    withCredentials : true
});

export const signup = async (signupData) => {
    const response = await axiosintance.post('/register', signupData);
    return response.data;
};

export const login = async (signupData) => {
    const response = await axiosintance.post('/login', signupData);
    return response.data;
};

export const Resetpassword = async (id, data) => {
    const response = await axiosintance.post(`/reset-password/${id}`, data);
    return response.data;
};
export const Logout = async ( ) => {
    const response = await axiosintance.post(`/logout`);
    return response.data;
};
export const getuserId = async (id) => {
    const response = await axiosintance.get(`/users/${id}`);
    return response.data;
};

export const createProcess = async (processdata) => {
    const response = await axiosintance.post(`/setting/create/process`, processdata);
    return response.data;
};

export const getallProcess = async () => {
    const response = await axiosintance.get(`/setting/processes`);
    return response.data;
};

export const createRole = async (processdata) => {
    const response = await axiosintance.post(`/setting/create/role`, processdata);
    return response.data;
};
export const updateCompleteStatus = async (id,billdata) => {
    const formData = new FormData();
        
        // Append all fields to the formData object
        for (const key in billdata) {
            formData.append(key, billdata[key]);
        }
    const response = await axiosintance.post(`/project/${id}/updateCompleted`, formData);
    return response.data;
};

export const getallRole = async () => {
    const response = await axiosintance.get(`/setting/roles`);
    return response.data;
};
export const getallCustomerDropdown = async () => {
    const response = await axiosintance.get(`/customers-dropdown`);
    return response.data;
};
export const getallEmployeesDropdown = async () => {
    const response = await axiosintance.get(`/employees-dropdown`);
    return response.data;
};
export const getallVendorDropdown = async () => {
    const response = await axiosintance.get(`/vendors-dropdown`);
    return response.data;
};
export const getTrack = async (id) => {
    const response = await axiosintance.get(`/project/${id}/track`);
    return response.data;
};
export const getDispatch = async (id) => {
    const response = await axiosintance.get(`/project/${id}/dispatch`);
    return response.data;
};
export const DeleteRoleId = async (id) => {
    const response = await axiosintance.delete(`/role/${id}`);
    return response.data;
};

export const createCustomer = async (customerdata) => {
    const formData = new FormData();
        
        // Append all fields to the formData object
        for (const key in customerdata) {
            formData.append(key, customerdata[key]);
        }

        const response = await axiosintance.post('/customer/create', formData, {
            headers: {
                'Content-Type': 'multipart/form-data' // Use multipart/form-data for file uploads
            }
        });
    return response.data;
};

export const createVendor = async (vendordata) => {
    const formData = new FormData();
        
    // Append all fields to the formData object
    for (const key in vendordata) {
        formData.append(key, vendordata[key]);
    }
    const response = await axiosintance.post(`/vendor/create`,  formData, {
        headers: {
            'Content-Type': 'multipart/form-data' // Use multipart/form-data for file uploads
        }
    });
    return response.data;
};

export const createProject = async (data) => {
    const formData = new FormData();

    for (const key in data) {
        const value = data[key];

        if (value === undefined || value === null) continue;

        // If it's a file (e.g. drawingFile)
        if (value instanceof File) {
            formData.append(key, value);
        }

        // Handle nested objects (e.g., dimensions)
        else if (typeof value === 'object' && !Array.isArray(value)) {
            for (const subKey in value) {
                // console.log({value,subKey})
                if (value[subKey] !== undefined && value[subKey] !== null) {
                    formData.append(`${key}[${subKey}]`, value[subKey]);
                }
            }
        }

        // Handle arrays (e.g., processes)
        else if (Array.isArray(value)) {
            value.forEach((item, index) => {
                if (typeof item === 'object') {
                    for (const subKey in item) {
                        if (item[subKey] !== undefined && item[subKey] !== null) {
                            formData.append(`${key}[${index}][${subKey}]`, item[subKey]);
                        }
                    }
                } else {
                    formData.append(`${key}[${index}]`, item);
                }
            });
        }

        // Primitive values
        else {
            formData.append(key, value);
        }
    }

    // Optional: Debugging FormData before sending
    // for (let pair of formData.entries()) {
    //     console.log(pair[0]+ ': ' + pair[1]);
    // }

    const response = await axiosintance.post(`/project`, formData);
    return response.data;
};



export const createEmployee = async (employeedata) => {
    const formData = new FormData();
        
    // Append all fields to the formData object
    for (const key in employeedata) {
        formData.append(key, employeedata[key]);
    }
    // console.log(employeedata)
    const response = await axiosintance.post(`/employee`,  formData, {
        headers: {
            'Content-Type': 'multipart/form-data' // Use multipart/form-data for file uploads
        }
    });
    return response.data;
};

export const getallcustomer = async(page = 1, limit = 5, search = "") => {
    const response = await axiosintance.get(`/customers?page=${page}&limit=${limit}&search=${search}`);
    return response.data;
};

export const getallProject = async (page = 1, limit = 5, search = "") => {
    const response = await axiosintance.get(`/projects?page=${page}&limit=${limit}&search=${search}`);
    return response.data;
};

export const getcustomerbyId = async (id) => {
    const response = await axiosintance.get(`/customer/${id}`);
    return response.data;
};

export const getAllEmployees = async (page = 1, limit = 5, search = "") => {
    const response = await axiosintance.get(`/employees?page=${page}&limit=${limit}&search=${search}`,{
        "X-Frame-Options": "ALLOWALL"
    });
    return response.data;
};

export const getAllVendors = async (page = 1, limit = 5, search = "") => {
    const response = await axiosintance.get(`/vendors?page=${page}&limit=${limit}&search=${search}`);
    return response.data;
};

export const getAllMetrials = async () => {
    const response = await axiosintance.get(`/setting/metrials`);
    return response.data;
};

export const createMetrial = async (processdata) => {
    const response = await axiosintance.post(`/setting/create/metrial`, processdata);
    return response.data;
};

export const UpdatecustomerbyId = async (id, data) => {
    const formData = new FormData();
        
    // Append all fields to the formData object
    for (const key in data) {
        formData.append(key, data[key]);
    }
    const response = await axiosintance.put(`/customer/${id}`, formData);
    return response.data;
};

export const UpdateEmployeebyId = async (id, data) => {
    const formData = new FormData();
    for (const key in data) {
        formData.append(key, data[key]);
    }
    const response = await axiosintance.put(`/employee/${id}`, formData,{
        headers: {
            'Content-Type': 'multipart/form-data' // Use multipart/form-data for file uploads
        }
    });
    return response.data;
};

export const UpdateprojectbyId = async (id, data) => {
    const formData = new FormData();
    
    for (const key in data) {
        if (data[key] instanceof File) {
            // Handle single file
            formData.append(key, data[key]);
        } 
        if (Array.isArray(data[key])) {
            // If it's an array, append each item appropriately
            data[key].forEach((item, index) => {
                // Append object properties directly
                for (const subKey in item) {
                    formData.append(`${key}[${index}][${subKey}]`, item[subKey]);
                }
            });
        } else if (key === 'customerID') {
            // Ensure customerID is appended as a string
            formData.append(key, data[key]._id || data[key]); // Adjust as necessary
        } else {
            if (data[key] && typeof data[key] === 'object' && !Array.isArray(data[key])) {
    // It's a nested object
    for (const subKey in data[key]) {
        formData.append(`${key}[${subKey}]`, data[key][subKey]);
    }
} else if (Array.isArray(data[key])) {
    // Existing logic for arrays
    data[key].forEach((item, index) => {
        if (typeof item === 'object') {
            for (const subKey in item) {
                formData.append(`${key}[${index}][${subKey}]`, item[subKey]);
            }
        } else {
            formData.append(key, item);
        }
    });
} else {
    // Primitive value
    formData.append(key, data[key]);
}

        }
    }
    const response = await axiosintance.put(`/project/${id}`, formData);
    return response.data;
};

export const UpdatevendorbyId = async (id, data) => {
    const formData = new FormData();
        
    // Append all fields to the formData object
    for (const key in data) {
        formData.append(key, data[key]);
    }
    const response = await axiosintance.put(`/vendor/${id}`, formData);
    return response.data;
};

export const DeletecustomerbyId = async (id) => {
    const response = await axiosintance.delete(`/customer/${id}`);
    return response.data;
};

export const DeleteEmployeeByID = async (id) => {
    const response = await axiosintance.delete(`/employee/${id}`);
    return response.data;
};

export const deleteVendorById = async (id) => {
    const response = await axiosintance.delete(`/vendor/${id}`);
    return response.data;
};

export const DeleteProcessId = async (id) => {
    const response = await axiosintance.delete(`/process/${id}`);
    return response.data;
};

export const deleteMetrialId = async (id) => {
    const response = await axiosintance.delete(`/metrial/${id}`);
    return response.data;
};

export const deleteProjectId = async (id) => {
    const response = await axiosintance.delete(`/project/${id}`);
    return response.data;
};


export const getDashboardData = async () => {
    const response = await axiosintance.get(`/dashboard`);
    return response.data;
};

export const getDashboardEmployye = async(id)=>{
    const response = await axiosintance.get(`/dashboard/employee/${id}`);
    return response.data;
}

export const getEmployeeByToken = async()=>{
    const response = await axiosintance.post('get-data/token')
    return response.data
}